import { useEffect, useRef, useState } from 'react';

export default function useIsMounted() {
  const isMounted = useRef(false);

  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);

  return isMounted;
}

/**
 * Caution: this hook will force a re-render right after mount. If possible,
 * please use `useIsMounted()` instead.
 *
 * This hook is useful when you need to ensure a render or effect only runs on
 * the client (no SSR) in a “two pass rendering” pattern. It’s also needed to
 * ensure correct types for some MUI props.
 *
 * See https://www.joshwcomeau.com/react/the-perils-of-rehydration for details.
 */
export function useIsMountedTwoPass() {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  return isMounted;
}
